import React, { useState } from 'react';
import { useArgoContext } from '@awsscm/argo-core';
import AppLayout from '@amzn/awsui-components-react-v3/polaris/app-layout';
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import { ApolloProvider } from '@apollo/react-hooks';
import getApolloClient from './gql';
import Pages from './pages';
import Footer from '@awsscm/argo-core/argo/ui/footer';
import Header from '@awsscm/argo-core/argo/ui/header';
import Navigation from '@awsscm/argo-core/argo/ui/navbar';
import NavigationMenu from './pages/NavigationMenu/NavigationMenu';
import ShipmentHelp from './tools/ShipmentHelp';
import './App.css'
import { getForbiddenMessage } from './util/ReactUtil';
import { Alert } from '@amzn/awsui-components-react-v3';
import { ERROR_MESSAGE } from './util/ConfigConstants';

export default function App() {
  const context = useArgoContext();
  const [notificationMessage, setNotificationMessage] = useState<React.ReactNode>();

  return (
    // Adding an Apollo provider high in the component tree makes it available for all children to access.
    // See https://www.apollographql.com/docs/react/get-started/ for more info.
    <ApolloProvider client={getApolloClient(context)}>
      <Box id='awsscm-header'>
        <Header />
      </Box>
      <Box>
        <AppLayout
          tools={<ShipmentHelp />}
          content={<Pages setNotificationMessage={setNotificationMessage}/>}
          navigation={<Navigation navigationMenu={<NavigationMenu />} />}
          footerSelector='#awsscm-footer'
          headerSelector='#awsscm-header'
          notifications={
            notificationMessage ? 
            <Alert
              dismissAriaLabel="Close alert"
              type="error"
              header={ERROR_MESSAGE.GENERIC_ACCESS_DENIED_ERROR_MESSAGE}>
              {getForbiddenMessage(notificationMessage, false)} 
            </Alert> : 
            null}
        />
      </Box>
      <Box id='awsscm-footer'>
        <Footer />
      </Box>
    </ApolloProvider>
  );
}

document.body.classList.add('awsui-visual-refresh');